import { Injectable } from '@angular/core';
import { CacheService } from 'src/app/_service/cache.service';
import { throwError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceAdapterService {
  serviceDetails: any = {};
  constructor(private cacheService: CacheService) { 
    if(sessionStorage.hasOwnProperty('serviceconfig')){
      this.serviceDetails = JSON.parse(sessionStorage.getItem('serviceconfig') || '{}');
    }
  }

  backendServiceCall<T>(serviceId:string,requestpayload = {},params?:{}): Observable<T[]>{
        let serviceDet = this.getServiceDetailsBasedOnServiceId(serviceId);
        if(Object.keys(serviceDet).length === 0 && serviceDet.constructor === Object){
           return throwError("ServiceId Not Found!");
        }else{
          return this.cacheService.getServiceData<T>(serviceId,serviceDet,requestpayload,params);
        }
  }

  getServiceDetailsBasedOnServiceId(serviceId: string){
    if(sessionStorage.hasOwnProperty('serviceconfig')){
      this.serviceDetails = JSON.parse(sessionStorage.getItem('serviceconfig') || '{}');
    }
        if(this.serviceDetails.hasOwnProperty(serviceId)){
            return this.serviceDetails[serviceId];
        }else{
            return {};
      }
  }

}
